import "./components/product/base";

if (document.querySelector(".section-product-routine")) {
    import("./components/products/product-routine.js").then(({ init }) =>
        init(),
    );
}

if (import.meta.hot) {
    import.meta.hot.accept();
}
